var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ctk-collapse-nav-item',{staticClass:"shipments-sidebar-item",attrs:{"to":{
    name: 'Shipments',
    params: {
      state: _vm.state
    }
  },"title":_vm._f("capitalize")(_vm.$tc('shipments.titles.shipments.menu.state.' + _vm.state, 2)),"count":_vm.count,"has-dot":_vm.hasDot}})}
var staticRenderFns = []

export { render, staticRenderFns }